class Accordion {
	constructor(blockEl) {
		this.accordion = blockEl;
		this.itemHeaders = this.accordion.querySelectorAll('.accordion-container__header');

		this.setEventHandlers();
	}

	setEventHandlers() {
		this.itemHeaders.forEach(accHeader => {
			accHeader.addEventListener('click', () => {
				if (accHeader.classList.contains('active')) {
					accHeader.classList.remove('active');
				} else {
					this.itemHeaders.forEach(h => h.classList.remove('active'));
					accHeader.classList.add('active');
				}

				const activeHeader = this.accordion.querySelector('.accordion-container__header.active');

				const event = new CustomEvent('accordionActiveChanged', {
					detail: activeHeader ? activeHeader.dataset.accHeading : null,
					bubbles: true,
					composed: true
				});
				
				this.accordion.dispatchEvent(event);
			});
		});
	}
}

export default Accordion;
